import * as React from "react";
const IconPin = (props) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22.475c1-5 8-5.582 8-12a8 8 0 1 0-16 0c0 6.418 7 7 8 12"
      fill="#000"
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.667 8.391c0-.387 0-.581-.043-.74a1.25 1.25 0 0 0-.884-.884c-.159-.042-.353-.042-.74-.042-.388 0-.581 0-.74.042a1.25 1.25 0 0 0-.884.884c-.043.159-.043.353-.043.74m-.5 5.834h4.334c.7 0 1.05 0 1.317-.137a1.25 1.25 0 0 0 .546-.546c.137-.267.137-.617.137-1.317V10.39c0-.7 0-1.05-.137-1.317a1.25 1.25 0 0 0-.546-.546c-.267-.137-.617-.137-1.317-.137H9.833c-.7 0-1.05 0-1.317.137a1.25 1.25 0 0 0-.547.546c-.136.267-.136.617-.136 1.317v1.834c0 .7 0 1.05.136 1.317.12.235.312.427.547.546.267.137.617.137 1.317.137"
      stroke="#fff"
      strokeWidth={1}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default IconPin;
